import {AsyncPipe} from '@angular/common';
import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {AnnotationListItemComponent} from '@app/annotation/annotation-list-item/annotation-list-item.component';
import {Annotation, AnnotationService} from '@app/annotation/annotation.service';

import {Asset} from '@app/asset';

import {Observable} from 'rxjs';

@Component({
    selector: 'frog-annotation-list',
    templateUrl: './annotation-list.component.html',
    styleUrls: ['./annotation-list.component.scss'],
    imports: [
        AnnotationListItemComponent,
        MatFormField,
        MatLabel,
        MatInput,
        ReactiveFormsModule,
        MatButton,
        AsyncPipe,
    ],
})
export class AnnotationListComponent implements OnInit, OnChanges {
    @Input() asset: Asset;

    public annotations$: Observable<Annotation[]>;
    public contentControl: UntypedFormControl;

    constructor(private annotationService: AnnotationService) {
        this.contentControl = new UntypedFormControl('');
    }

    ngOnInit(): void {
        this.annotations$ = this.annotationService.comments$;
    }

    ngOnChanges(changes: SimpleChanges) {
        this.annotationService.annotationsForAsset(this.asset.id);
    }

    addComment() {
        const value = this.contentControl.value;
        const annotation = new Annotation();
        annotation.comment = value;
        annotation.timestamp = -1;
        annotation.asset = this.asset.id;

        this.annotationService.create(annotation)
            .subscribe();
        this.contentControl.reset('');
    }
}
